import applicationMode from '../helper/applicationMode';

export default function appModes(mapOptions) {
    let {
        LegendEnabled,
        InfoWindowEnabled,
        MeasureEnabled,
        DrawingEnabled,
        Enable3DMode,
        FullScreenControl,
        RotateControl,
        MapTypeControl,
        ZoomControl,
        StreetViewControl,
        Draggable,
        Scrollwheel,
        ActionMenuEnabled,
        WorkspaceEnabled,
        ApplicationMode
    } = mapOptions;

    if (
        ApplicationMode !== applicationMode.single &&
        ApplicationMode !== applicationMode.mini &&
        ApplicationMode !== applicationMode.custom
    ) {
        ApplicationMode = applicationMode.default;
    }

    if (ApplicationMode == applicationMode.default) {
        DrawingEnabled = true;
        LegendEnabled = true;
        InfoWindowEnabled = true;
        MeasureEnabled = true;
        WorkspaceEnabled = true;
        Enable3DMode = true;
        ActionMenuEnabled = true;
        FullScreenControl = true;
        RotateControl = true;
        MapTypeControl = true;
        ZoomControl = true;
        StreetViewControl = true;
        Draggable = true;
        Scrollwheel = true;
    }

    if (ApplicationMode == applicationMode.single) {
        DrawingEnabled = false;
        LegendEnabled = true;
        InfoWindowEnabled = false;
        MeasureEnabled = false;
        WorkspaceEnabled = false;
        Enable3DMode = false;
        ActionMenuEnabled = false;

        FullScreenControl = false;
        RotateControl = true;
        MapTypeControl = true;
        ZoomControl = true;
        StreetViewControl = true;
        Draggable = true;
        Scrollwheel = true;
    }

    if (ApplicationMode == applicationMode.mini) {
        DrawingEnabled = false;
        LegendEnabled = false;
        InfoWindowEnabled = false;
        MeasureEnabled = false;
        WorkspaceEnabled = false;
        Enable3DMode = false;
        ActionMenuEnabled = false;
        FullScreenControl = false;
        RotateControl = false;
        MapTypeControl = false;
        ZoomControl = false;
        StreetViewControl = false;
        Draggable = false;
        Scrollwheel = false;
    }

    if (WorkspaceEnabled == true || MeasureEnabled == true) ActionMenuEnabled = true;

    if (WorkspaceEnabled != true && MeasureEnabled != true) ActionMenuEnabled = false;

    return {
        LegendEnabled,
        InfoWindowEnabled,
        MeasureEnabled,
        WorkspaceEnabled,
        DrawingEnabled,
        Enable3DMode,
        FullScreenControl,
        RotateControl,
        MapTypeControl,
        ZoomControl,
        StreetViewControl,
        Draggable,
        Scrollwheel,
        ActionMenuEnabled,
        ApplicationMode
    };
}
